import { Cloud, FileText, LoaderCircle, Trash2 } from "lucide-react";
import { formatBytes } from "../lib/text";
import type { StoredPdf } from "../types";
import { Dropzone } from "./Dropzone";

type LibraryPanelProps = {
  documents: StoredPdf[];
  loading: boolean;
  error: string;
  uploadProgress: number | null;
  onFile: (file: File) => void;
  onOpen: (document: StoredPdf) => void;
  onRemove: (document: StoredPdf) => void;
};

export function LibraryPanel({
  documents,
  loading,
  error,
  uploadProgress,
  onFile,
  onOpen,
  onRemove,
}: LibraryPanelProps) {
  return (
    <section className="content-panel">
      <div className="section-title-row">
        <div>
          <p className="eyebrow">CİHAZDA ÖZEL DEPOLAMA</p>
          <h1>Kitap arşivim</h1>
          <p className="muted">PDF ve EPUB kitapların bu tarayıcıda saklanır, hiçbir sunucuya yüklenmez.</p>
        </div>
        <span className="count-badge"><Cloud size={16} /> {documents.length} belge</span>
      </div>

      {
        <>
          <Dropzone onFile={onFile} compact />
          {uploadProgress !== null && (
            <div className="upload-progress">
              <div><LoaderCircle className="spin" size={18} /> Kitap kaydediliyor</div>
              <strong>%{uploadProgress}</strong>
              <span style={{ width: `${uploadProgress}%` }} />
            </div>
          )}
          {error && <p className="form-error">{error}</p>}

          {loading ? (
            <p className="muted">Belgelerin yükleniyor…</p>
          ) : documents.length === 0 ? (
            <div className="large-empty small">
              <FileText size={31} />
              <h2>Henüz kayıtlı kitap yok</h2>
              <p>İlk PDF veya EPUB kitabını yukarıdaki alana bırak.</p>
            </div>
          ) : (
            <div className="library-list">
              {documents.map((document) => (
                <article key={document.id} className="library-row">
                  <button className="library-open" onClick={() => onOpen(document)}>
                    <span className={`pdf-file-icon ${document.type === "epub" ? "is-epub" : ""}`}>
                      {document.type.toLocaleUpperCase()}
                    </span>
                    <span>
                      <strong>{document.name}</strong>
                      <small>
                        {formatBytes(document.size)} ·{" "}
                        {new Intl.DateTimeFormat("tr-TR", {
                          day: "numeric",
                          month: "short",
                          year: "numeric",
                        }).format(new Date(document.uploadedAt))}
                      </small>
                    </span>
                  </button>
                  <button
                    className="icon-button danger"
                    onClick={() => onRemove(document)}
                    aria-label={`${document.name} belgesini sil`}
                  >
                    <Trash2 size={18} />
                  </button>
                </article>
              ))}
            </div>
          )}
        </>
      }
    </section>
  );
}
